<template>
  <div class="PrefabCreator_summary">
   <div class="d-flex align-items-center justify-content-between" style="    padding: 40px 20px 0;">
     <h2>Sammanfattning</h2>
     <div class="CloseIcon" @click="activateTopMenu('ProductChooser')">
       <svg data-v-7ba5bd90="" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect data-v-7ba5bd90="" width="24" height="24" rx="12" fill="#F3F3F3"></rect><path data-v-7ba5bd90="" d="M15.375 8.625L8.625 15.375" stroke="#0A1D29" stroke-width="1.5" stroke-linecap="square"></path><path data-v-7ba5bd90="" d="M15.375 15.375L8.625 8.625" stroke="#0A1D29" stroke-width="1.5" stroke-linecap="square"></path></svg>
     </div>
   </div>
    <div class="SummaryProducts">
      <div class="BuilderCleanSummary_order">
        <div v-for="(row,i) in rows" :key="row.article.article_nr"
             v-show="parseInt(row.article.out_price_ex_sek) > 0 && row.article.visible_for_customer"
             :data-index="i"
             :data-articleId="row.article.article_nr"
             class="ProductRow">
          <div class="ProductRow_title">
            <div v-if="row.article.image !== false" class="image_holder">
              <img :src="row.article.image" alt="">
            </div>
            <div v-else class="image_holder">
              <img src="@/assets/images/logo.svg" alt="">
            </div>

            <div class="title_holder">{{ row.article.title }}</div>
          </div>
          <div class="price_holder d-flex align-items-center">
            <span>{{ formatNum(calculateTotalInc(row.article)) }} {{ $t('valuta') }}</span>
            <div class="pl-2 deleteSummary" @click="deleteSummary(row)">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16.875 4.375H3.125" stroke="black" stroke-width="1.5" stroke-linecap="round"
                      stroke-linejoin="round"/>
                <path d="M8.125 8.125V13.125" stroke="black" stroke-width="1.5" stroke-linecap="round"
                      stroke-linejoin="round"/>
                <path d="M11.875 8.125V13.125" stroke="black" stroke-width="1.5" stroke-linecap="round"
                      stroke-linejoin="round"/>
                <path
                    d="M15.625 4.375V16.25C15.625 16.4158 15.5592 16.5747 15.4419 16.6919C15.3247 16.8092 15.1658 16.875 15 16.875H5C4.83424 16.875 4.67527 16.8092 4.55806 16.6919C4.44085 16.5747 4.375 16.4158 4.375 16.25V4.375"
                    stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path
                    d="M13.125 4.375V3.125C13.125 2.79348 12.9933 2.47554 12.7589 2.24112C12.5245 2.0067 12.2065 1.875 11.875 1.875H8.125C7.79348 1.875 7.47554 2.0067 7.24112 2.24112C7.0067 2.47554 6.875 2.79348 6.875 3.125V4.375"
                    stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
          </div>

        </div>

      </div>
    </div>
  </div>
</template>

<script>
import Footer from "@/components/Footer";
import helpers from "@/helpers";

export default {
  name: "Summary",
  components: {Footer},
  data() {
    return {
      helpers
    }
  },
  computed:{
    rows(){
      return this.$store.state.order.rows
    }
  },
  methods: {
    choose(row) {
      let findA =  Array.from(this.$store.state.order.rows).findIndex(x=>  x.category.category_nr === row.category.category_nr)
      let currentRowArticle = {...this.$store.state.order.rows[findA]}
      currentRowArticle.article = row.article
      //this.$store.commit('reset_select_row',{val:currentRowArticle,index:findA})

      this.$store.commit('commit_active_row', currentRowArticle)
      this.$store.commit('logic', this.$store.state.layers)
    },
    deleteSummary(row){
      let availableArticles = this.$store.getters.SubCategories.find(x=>x.category_nr === row.category.category_nr);
      let newRow = availableArticles.LinkedArticles[0]

      this.choose(newRow)
    },
    formatNum(num) {
      num = parseFloat(num)

      // If it is a float, restrict to 2 decimals
      //num = num % 1 !== 0 ? num.toFixed(2) : num.toFixed(0)
      num = Math.round(num).toFixed(0)
      num = num.replace('.', ',')

      return ! num ? num : num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")
    },
    num(num) {
      if (typeof num === 'string') {
        num = num.replace(',', '.')
      }

      return isNaN(parseFloat(num)) ? 0 : parseFloat(num)
    },
    calculateInc(article) {
      return this.num(article.out_price_ex_sek) * 1.25
    },
    calculateTotalInc(article) {
      return this.num(article.quantity) * this.calculateInc(article) - this.num(article.discount)
    },
    commit_next_view(){
      this.$store.commit('commit_current_view','kassa')
      this.$store.commit('commit_current_category', {})
      this.$store.commit('commit_activeTab','ProductChooser')
    },
    activateTopMenu() {
      this.$store.commit('commit_activeTab', 'ProductChooser')
    }
  }
}
</script>
<style lang="scss" scoped>
input.filled {
  i.icon-checkbox-checked {
    transition: all 1s ease-in-out;
    opacity: 1 !important;
  }
}
.BuilderCleanSummary_order {
 // padding: 0 28px;
  overflow-y: scroll;
  min-height: 200px;
  flex: 1;
  height: 100%;

  &::-webkit-scrollbar {
    display: none;
  }
  .deleteSummary {
    cursor: pointer;
    padding-left: 10px;
    display: none;
    &:hover {

      opacity: 0.8;
    }
  }
  .ProductRow {
    display: flex;
    align-items: center;
    gap: 20px;
    justify-content: space-between;
    padding: 10px 10px;
    @media screen {
      padding: 10px 5px;
    }
    cursor: pointer;
    &:hover{
      background-color: #f8f8f8;
      .deleteSummary{
        display: block;
      }
    }

    &:not(:last-of-type) {
      border-bottom: 1px solid var(--gray-05, #E8E8E8);
    }

    .ProductRow_title {
      display: flex;
      gap: 19px;
      align-items: center;

      .image_holder {
        img {
          width: 32px;
          height: 32px;
          border-radius: 50%;
          object-fit: cover;
        }

      }

      .title_holder {
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        color: var(--base-primary, #061B3A);
        text-overflow: ellipsis;
        overflow: hidden;
        width: 160px;
        white-space: nowrap;
      }
    }

    .price_holder {
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      color: var(--base-primary, #061B3A);
    }

  }
}
.PrefabCreator_summary {

  background-color: #fff;
  border-left: 1px solid var(--gray-05, #E8E8E8);
  padding: 5px 50px 5px 50px;
  @media screen and (max-width: 769px) {
    padding-left: 5px;
    padding-right: 5px;
  }

  .NextBtnHolder{
    width: 100%;
    flex-shrink: 1;
    .NextBtn{
      width: 100%;
      border-radius: 6px;
      display: flex;
      padding: 9px 18px;
      justify-content: center;
      align-items: center;
      gap: 10px;
      flex-shrink: 1;
      background: var(--base-primary, #061B3A);
      color: white;
      cursor: pointer;
      font-size: 18px;
      @media screen and (max-width: 791px ){
        font-size: 14px;
      }
      font-style: normal;
      font-weight: 500;
      &:hover{
        background-color: rgba(6, 27, 58, 0.9);
      }
    }
  }
  h2 {

    font-size: 24px!important;
    font-style: normal;
    line-height: 147.187%;
    font-weight: 600;
    margin: 0;

  }
  .CloseIcon {
    cursor: pointer;
    &:hover {
      opacity: 0.8;
    }
  }

  .PrefabCreator_footer {
    margin: auto 0;

  }

  .SummaryProducts {
    overflow-y: scroll;
    padding: 20px;

    &::-webkit-scrollbar {
      display: none;
    }

    ul {
      margin: 0;
      padding: 0;

      li {
        list-style: none;
        padding: 16px 0;
        gap: 12px;

        &:not(:last-of-type) {
          border-bottom: 1px solid #E2E2E2;
        }

        .CategoryTitle {
          color: var(--gray-black, #000);
          font-size: 16px;
          font-style: normal;
          font-weight: 600;
        }

        .SummaryProduct {
          display: flex;
          align-items: center;
          justify-content: space-between;

          .SummaryProductTitle {
            color: var(--gray-12, #0A1D29);
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
          }

          .SummaryProductPrice {
            color: var(--gray-12, #0A1D29);
            font-size: 14px;
            font-style: normal;
            font-weight: 500;
            line-height: normal;
          }
        }

      }
    }
  }

  .TotalHolder {

    padding: 20px;
    border-top: 1px solid #E2E2E2;
    margin-top: auto;
    box-shadow: 0px -1px 1px 0px rgba(0, 0, 0, 0.04), 0px -2px 8px 0px rgba(0, 0, 0, 0.05);

    .TotalHolderBody{
      display: flex;
      flex-direction: column;
      width: 100%;
      gap: 20px;
      .TotalHolderBodyTitle{
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
    }

    .TotalHolder_TITLE {
      color: var(--gray-12, #0A1D29);
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
    }

    .TotalHolder_PRICE {
      color: var(--gray-12, #0A1D29);
      font-size: 20px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
    }
  }
}
</style>
